<!-- <NavigationBackButton /> -->
<div class="border-card border-0 px-4 py-1 scroll-container" ref="create_enquiry_stages">
    <p class="ms-3 mt-2 text-x fw-bold">Enquiry Status Management</p>
    <div class=" ">
      <div class="card-header card-header-primary card-nav-tabs shadow rounded-lg mt-1">
          <div class="nav-tabs-navigation">
            <div class="nav-tabs-wrapper">
              <ul class="nav nav-tabs" data-tabs="tabs">
                <li class="border rounded-lg me-2 nav-item" :class="{ active: active_tab === 'Manage Status' , inactive: active_tab !== 'Manage Status' }">
                  <a class="text-white text-decoration-none nav-link text-xs" @click="set_active_tab('Manage Status')">
                    Manage Status
                  </a>
                </li>
                <li class="border rounded-lg me-2 nav-item" :class="{ active: active_tab === 'Sub-status Transition Rules' , inactive: active_tab !== 'Sub-status Transition Rules'}">
                  <a class="text-white text-decoration-none nav-link text-xs" @click="set_active_tab('Sub-status Transition Rules')">
                    Sub-status Transition Rules
                  </a>
                </li>
              </ul>
              <hr class="text-white"/>
            </div>
          </div>
      </div>
      <div class="card rounded-lg border-0 shadow mt-2">
        <div class="card-body">
          <!-- Status Management Tab Content -->
          <div v-if="active_tab ==='Manage Status'">
            <div class="accordion mb-3 border table-border-color rounded-lg" id="stages_accordion">
              <div class="accordion-item" v-for="(stage, index) in main_stages" :key="index">
                <h2 class="accordion-header ">
                  <div class="d-flex align-items-center w-100 p-2 border rounded-lg text-xxs shadow">
                    <!-- Main Statuses Input -->
                    <div class="position-relative flex-grow-1 me-2">
                      <input
                        type="text"
                        class="form-control form-control-sm ps-2 pe-5 text-xxs bg-white"
                        v-model="stage.name"
                        :readonly="!stage.editing"
                        :class="{'bg-white border-primary': stage.editing, 'bg-light border-0': !stage.editing}"
                      >
                    </div>
                    <button
                      class="btn btn-primary-dark btn-sm text-xxs mb-1"
                      data-bs-toggle="modal" data-bs-target="#add_sub_stage"
                      @click="open_add_sub_stage_modal(index)"
                    >
                      Add Sub-status
                    </button>
                    <a
                      class="fw-bold fs-6 p-0 ms-2 text-dark"
                      @click.stop="toggle_stage(index)"
                      type="button"
                    >
                      <i class="bi" :class="{'bi-chevron-down': !stage.expanded, 'bi-chevron-up': stage.expanded}"></i>
                    </a>
                  </div>
                </h2>

                <div
                  class="collapse"
                  :class="{ 'show': stage.expanded }"
                >
                  <div class="accordion-body">
                    <p class="text-dark text-xs mb-3 fw-bold">Sub-Statuses:</p>
                    <div class="mb-3">
                      <template v-if="stage.sub_stages && stage.sub_stages.length > 0">
                        <div class="d-flex align-items-center mb-2"
                          v-for="(sub_stage, sub_index) in stage.sub_stages" :key="sub_index">
                          <!-- Sub-Stage Inputs -->
                          <div class="position-relative flex-grow-1 me-2">
                            <input
                              type="text"
                              class="form-control form-control-sm text-xxs ps-2 pe-5 w-50"
                              v-model="sub_stage.name"
                              :readonly="!sub_stage.editing"
                              :class="{'bg-white border-primary': sub_stage.editing, 'bg-light border-0': !sub_stage.editing}"
                            >

                            <!-- Description input when editing -->
                            <select
                              v-if="sub_stage.editing"
                              class="form-select form-select-sm text-xxs ps-2 pe-5 w-50 mt-2"
                              v-model="sub_stage.next_sub_status_id"
                            >
                              <option value="" disabled selected>
                                {{ get_available_sub_statuses(stage.id, sub_stage.id).length > 0
                                  ? "Select next sub-status (optional)"
                                  : "No sub-statuses found" }}
                              </option>
                              <option
                                v-for="sub in get_available_sub_statuses(stage.id, sub_stage.id)"
                                :value="sub.id"
                              >
                                {{ sub.name }}
                            </option>
                          </select>

                            <!-- Mandatory checkbox when editing -->
                            <div v-if="sub_stage.editing" class="form-check mt-2">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="sub_stage.is_mandatory"
                                id="mandatory-checkbox"
                              >
                              <label class="form-check-label text-xxs text-dark" for="mandatory-checkbox">
                                Is Mandatory(optional)
                              </label>
                            </div>
                            <!-- Edit/Save Button -->
                            <button
                              class="btn btn-sm position-absolute top-0 end-0 me-4 p-1 btn-primary-dark text-xxs"
                              @click="toggle_edit_sub_stage(index, sub_index)"
                              :disabled="loading"
                            >
                              <i class="bi" :class="{
                                'bi-pencil-fill': !sub_stage.editing,
                                'bi-check': sub_stage.editing
                              }"></i>
                            </button>
                            <!-- Delete Button -->
                            <button
                              class="btn btn-sm position-absolute top-0 end-0 p-1 btn-primary-dark text-xxs"
                              @click="remove_sub_stage(index, sub_index)"
                              :disabled="loading || sub_stage.editing"
                            >
                              <i class="bi bi-trash-fill"></i>
                            </button>
                        </div>
                      </div>
                      </template>
                      <div v-else class="text-muted text-xxs">
                        No sub-statuses added yet
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Transition Rules Tab Content -->
          <div v-else-if="active_tab === 'Sub-status Transition Rules'">
            <CreateTransitionRules />
          </div>
        </div>
      </div>
    </div>
</div>


  <!-- Add Sub-Stage Modal -->
<teleport to="body">
  <div class="modal fade" id="add_sub_stage" tabindex="-1" aria-labelledby="add_sub_stage_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h5 class="modal-title text-white text-xxs">Add Sub-status to {{ current_main_stage_name }}</h5>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="modal-form-label form-label text-xxs">Sub-status Name :</label>
            <input
              type="text"
              class="modal-form-control form-control text-xxs"
              placeholder="Enter sub-status name"
              v-model="new_sub_stage.name"
            />
          </div>

          <div class="mb-3 position-relative">
            <label class="modal-form-label form-label text-xxs">Select next main status (optional) :</label>
            <select
              class="modal-form-select form-select form-select-sm text-xxs"
              v-model="new_sub_stage.next_main_status_id"
            >
              <option disbaled hidden value="">Select next main status (optional)</option>
              <option
                v-for="main in main_stages"
                :value="main.id"
                :key="'main-'+main.id"
              >
                {{ main.name }}
              </option>
            </select>
          </div>

          <div class="form-check mb-3 d-flex align-items-center">
            <input class="form-check-input text-xxs me-1" type="checkbox" id="mark-mandatory" v-model="new_sub_stage.is_mandatory">
            <label class="form-check-label text-xxs mt-1" for="mark-mandatory">
              Mark as mandatory
            </label>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            @click="create_enquiry_sub_status"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>




